<!-- 
	DEPRECIATED
	OptOutProcessing
	props: OptOuts
  	role: User
	Called by @/views/OptOut if user has previously requested an optout but it has yet to be processed by an admin
-->

<template>
	<div class="opt-out-processing py-12">
		<div class="text-2xl pb-4">
			It appears that you have already requested to Opt Out, or are not currently enrolled in the WinWin
			Staff Lottery Payroll Deduction Program.
		</div>
		<div class="pb-4">
			If this was not submitted by you, or you feel there was an error in this
			request,
		</div>
		<div class="pb-4">
			Requests to Opt Out can take up to
			<span class="font-bold">two weeks</span> to process.
		</div>
		<div>
			Please contact customer service at
			<a href="tel:+18665946946" class="winwin-aqua font-bold"
				>1 (866) 594 - 6946</a
			>
		</div>
	</div>
</template>
<script>
	export default {
		name: "OptOutProcessing"
	};
</script>
